<template>
  <div id="PurpleRibbonPage" class="basic-page">
    <PageNav />
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import PageNav from '@/components/PageNav'

export default {
  name: 'PurpleRibbonPage',
  components: {
    PageNav,
  },
}
</script>
